import { ValueOf } from '@/types/util';

export const EPhysicalCardStatus = {
  CREATE: '有効化待ち',
  ACTIVE: '有効',
  DISABLED: '利用停止',
} as const;

export type PhysicalCardStatusKey = keyof typeof EPhysicalCardStatus;
export type PhysicalCardStatusValue = ValueOf<typeof EPhysicalCardStatus>;

export const physicalCardStatusKeys = Object.keys(EPhysicalCardStatus) as PhysicalCardStatusKey[];

/** v-select用items */
export const physicalCardStatusItems = physicalCardStatusKeys
  .map((key) => ({
    title: EPhysicalCardStatus[key],
    value: key,
  }));
